import { QueovalBase, QueovalDate } from '../global';

export class SignatureModel extends QueovalBase {
  public strIdDonneePere: string;
  public strIdDonneeFils: string;
  public strNomRelation: string;
  public strPath: string;
  public pathExistButUnfounded: boolean;
  public updateIsAuthorized: boolean;
  public idLien: string;
  public strNom: string;
  public infosLienAlreadyExist: boolean;
  public strRelationBloquante: string;

  public eSignatureModel: ElectronicSignatureModel;

}

/// Signature electronique jesignexpert
export class ElectronicSignatureModel {

  public isTokenUserExpired: boolean;
  public strInfoTokenOffice: string;
  public strTokenURL: string;
  public strIdTransaction: string;
  public strEtatTransaction: string;
  public strIdDocument: string;
  public apiNameSignature: string;
  public documentToESigned: DocumentToESigned;
  public lstSignataires: Array<ESignataire>;
  public lstGroupeCollaborateurs: Array<GroupeCollaborateur>;
  public lstClients: Array<PersonneMorale>;
  public widthDoc: number;
  public heightDoc: number;
  public paramESignature: ParamsESignature;

  public ElectronicSignatureModel() {
    this.documentToESigned = new DocumentToESigned();
    this.lstSignataires = [];
    this.lstGroupeCollaborateurs = [];
    this.lstClients = [];
    this.paramESignature = new ParamsESignature();
  }

}

export class DocumentToESigned {
  public titre: string = '';
  public date: QueovalDate;
  public reference: string;
  public fileName: string;
  public lectureSeule: boolean;
  public fileExist: boolean;
  public information: string;

  public toDownload: boolean;
  public etatTransac: string;
  public idTransac: string;
  public msgTransac: string;

}


export class PersonneMorale {
  public idClient: string;
  public raisonSocialeClient: string;
  public lstDirigeants: Array<PersonnePhysique>;
  public lstContacts: Array<PersonnePhysique>;
}

export class PersonnePhysique {
  
  public id: string;
  public value: string;
  public email: string;
  public phone: string;
  public bureau: string;
  public isChecked: boolean;
}

export class ESignaturePosition {
  public numero: number;
  public info: string;
  public isVisible: boolean;
  public posX: number;
  public posY: number;
  public posXcalc: number;
  public posYcalc: number;
  public blink: boolean = false;
}


export class ESignataire extends PersonnePhysique {
  public position: ESignaturePosition;
}


export class GroupeCollaborateur {
  public id: string;
  public name: string;
  public trigramme: string;
  public collapseMode: number;
  public isVisible: boolean;
  public lstCollaborateurs: Array<PersonnePhysique>;

  public GroupeCollaborateur() {
    this.lstCollaborateurs = [];
    this.isVisible = true;
    this.collapseMode = 1;
  }
}

export class ParamsESignature {
  public host: string;
  public shortcut: string;
  public secret: string;
  public isSecret: boolean;
  public certificat: string;
  public widthDoc: number;
  public heightDoc: number;
  public eSignaturePositions: Array<ESignaturePosition>;
  public eScellementSignaturePositions: Array<ESignaturePosition>;

  public ParamsESignature() {
    this.eSignaturePositions = [];
    this.eScellementSignaturePositions = [];
  }
}                  
